import { Subdivision, User } from './user'

export enum ObjectInfoFirst {
  REQUEST_MY = '1_request_my',
  APPROVES = '1_approves',
  CHECKLISTS = '1_checklists',
  MANAGERS = '1_managers',
  REQUEST_ALL = '1_request_all',
  REQUEST_COMMAND = '1_request_command',
  COMMAND_SHOW = '1_command_show',
  SUBDIVISION = '1_subdivision',
}

export enum ObjectInfoTwo {
  APPROVES = '2_approves',
  CHECKLISTS = '2_checklists',
  SUBDIVISION = '2_subdivision',
  SUBDIVISION_ADMIN = '2_subdivision_admin',
  WINNERS = '2_winners',
}

export enum ObjectInfoThree {
  APPROVES = '3_approves',
  CHECKLISTS = '3_checklists',
  SUBDIVISION = '3_subdivision',
  WINNERS = '3_winners',
}

export enum ObjectInfoFour {
  APPROVES = '4_approves',
  CHECKLISTS = '4_checklists',
  SUBDIVISION = '4_subdivision',
  WINNERS = '4_winners',
}

export type ProfileInfo = {
  '1_request_my'?: N1RequestMy
  '1_approves'?: N1Approves[]
  '1_checklists'?: N1Checklists[]
  '1_managers'?: User[]
  '1_request_all'?: N1RequestAll[]
  '1_request_command'?: N1RequestCommand[]
  '1_command_show'?: N1CommandShow[]
  '1_subdivision'?: N1Subdivision[]
  '2_checklists'?: N2Checklists[]
  '2_approves'?: N2Approves[]
  '2_subdivision'?: N2Subdivision[]
  '2_winners'?: N2Winners[]
  '2_subdivision_admin'?: N2SubdivisionAdmin[]
  '3_subdivision'?: N3Subdivision[]
  '3_checklists'?: N3Checklists[]
  '3_approves'?: N3Approves[]
  '3_winners'?: N2Winners[]
  '4_checklists'?: N4Checklists[]
  '4_approves'?: N4Approves[]
  '4_subdivision'?: N3Subdivision[]
  '4_winners'?: N2Winners[]
}

export type N2Approves = {
  nomination: Nomination
  requests: RequestsApproves[]
}

export type N3Approves = {
  nomination: Nomination
  requests: RequestsApproves[]
}

export type N4Approves = {
  nomination: Nomination
  requests: RequestsApproves[]
}

export type N1Subdivision = {
  id: number
  status: string
  statusName: string
  nomination: Nomination
  subdivision: any
  command: Command
  acceptModer: boolean
}

export type N2Subdivision = {
  subdivision: Subdivision
  requests: Requests[]
}

export type N2SubdivisionAdmin = {
  mms: any[]
  name: string
}

export type N3Subdivision = {
  name: string
  group: GroupN3Subdivision[]
}

export type GroupN3Subdivision = {
  user: User
  requests: Requests[]
}

export type N2Winners = {
  id: number
  status: string
  statusName: string
  nomination: Nomination
  subdivision: Subdivision
  command: Command
  acceptModer: boolean
}

export type N1RequestMy = {
  id: number
  status: string
  command: Command
  statusName: string
  acceptModer: boolean
  nomination: Nomination
}

export type N1Approves = {
  id: number
  ball: number
  status: string
  command: Command
  statusName: string
  finalStatus: string
  acceptModer: boolean
  finalBtnShow: boolean
  nomination: Nomination
  finalStatusName: string
  checklists: Checklist[]
}

export type N1Checklists = {
  id: number
  status: string
  command: Command
  statusName: string
  checklist: Checklist
  acceptModer: boolean
  nomination: Nomination
}

export type N1RequestAll = {
  id: number
  status: string
  command: Command
  statusName: string
  acceptModer: boolean
  nomination: Nomination
}

export type N1RequestCommand = {
  requests: Request[]
  nomination: Nomination
}

export type N1CommandShow = {
  id: number
  status: string
  command: Command
  statusName: string
  acceptModer: boolean
  nomination: Nomination
}

export type N2Checklists = {
  subdivision: Subdivision
  requests: Requests[]
}

export type N3Checklists = {
  user: User
  requests: Requests[]
}

export type N4Checklists = {
  user: User
  requests: Requests[]
}

export type Checklist = {
  l1: any
  l2: any
  ball: any
  id: number
  percent: any
  status: string
  moderUser: User
  endDatetime: string
}

export type Request = {
  id: number
  user: User
}

export interface Nomination {
  id: number
  name: string
  type: number
}

export interface Command {
  id: number
  name: string
  users: User[]
  nomination: Nomination
}

export type Region = {
  id: number
  name: string
}

export type Requests = {
  id: number
  status: string
  command: Command
  statusName: string
  checklist: Checklist
  acceptModer: boolean
  nomination: Nomination
}

export type RequestsApproves = {
  id: number
  ball: number
  status: string
  command: Command
  statusName: string
  finalStatus: string
  acceptModer: boolean
  finalBtnShow: boolean
  nomination: Nomination
  finalStatusName: string
  checklists: Checklist[]
  subdivision: Subdivision
}
